import { ChangeDetectionStrategy, Component, Input, OnInit } from '@angular/core';
import { Product } from '@vestiaire/api-sdk-angular';

@Component({
  selector: 'vc-product-price',
  templateUrl: './product-price.component.html',
  styleUrls: ['./product-price.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ProductPriceComponent implements OnInit {
  @Input()
  product: Product;
  @Input()
  displayTaxInfo = false;

  constructor() {}

  ngOnInit() {}

  get hasPromotionApplied(): boolean {
    return this.product.regularPrice && this.product.regularPrice.cents > 0;
  }
}
